import React from 'react';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

const DetailsPanelEditSortableList = ({
  children,
  groups,
  onSortEnd,
  onSortStart,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;

    const oldIndex = groups.findIndex((g) => (g[0].id || g[0].title) === active.id);
    const newIndex = groups.findIndex((g) => (g[0].id || g[0].title) === over.id);

    if (oldIndex === -1 || newIndex === -1) return;

    const updatedGroups = arrayMove(groups, oldIndex, newIndex);
    onSortEnd?.({ oldIndex, newIndex, updatedGroups });
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={onSortStart}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={groups.map((g) => g[0].id || g[0].title)}
        strategy={verticalListSortingStrategy}
      >
        {children}
      </SortableContext>
    </DndContext>
  );
};

export default DetailsPanelEditSortableList;
